import { render } from "./ProductPrice.vue?vue&type=template&id=009a0c1e&scoped=true"
import script from "./ProductPrice.vue?vue&type=script&lang=js"
export * from "./ProductPrice.vue?vue&type=script&lang=js"

import "./ProductPrice.vue?vue&type=style&index=0&id=009a0c1e&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-009a0c1e"]])

export default __exports__